import React from 'react';
import classNames from 'classnames';
import {
  DatePicker,
} from '@fluentui/react';
import PropTypes from 'prop-types';
import { getDayPickerStrings } from './utils';

export const DatePickerBasic = (props) => {
  const {
    label, maxDate, minDate, dateValue, placeholder, ariaLabel, onDateChange, disabled, onFormatDate, className, i18n,
  } = props;
  const handleDateSelection = (d) => {
    onDateChange(d);
  };

  return (
    <div className={classNames('date-content', className)}>
      <DatePicker
        placeholder={placeholder}
        className="date"
        value={dateValue}
        maxDate={maxDate && new Date(maxDate)}
        minDate={minDate && new Date(minDate)}
        calendarProps={{
          calendarDayProps: { className: 'date-picker-day' },
          calendarMonthProps: { className: 'date-picker-year-month' },
        }}
        formatDate={onFormatDate}
        onSelectDate={d => handleDateSelection(d)}
        ariaLabel={ariaLabel}
        disabled={disabled}
        label={label}
        strings={getDayPickerStrings(i18n)}
      />
    </div>
  );
};

DatePickerBasic.propTypes = {
  maxDate: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.object,
  ]),
  minDate: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.object,
  ]),
  dateValue: PropTypes.shape({}),
  placeholder: PropTypes.string,
  ariaLabel: PropTypes.string,
  onDateChange: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  onFormatDate: PropTypes.func.isRequired,
  label: PropTypes.string,
  className: PropTypes.string,
  i18n: PropTypes.shape({
    getString: PropTypes.func.isRequired,
  }).isRequired,
};

DatePickerBasic.defaultProps = {
  className: '',
  maxDate: '',
  minDate: '',
  dateValue: undefined,
  placeholder: 'Select a date...',
  ariaLabel: 'Select a date',
  disabled: false,
  label: '',
};
